import { EnvironmentProviders, inject, isDevMode, Provider, provideEnvironmentInitializer } from "@angular/core";
import { provideServiceWorker } from "@angular/service-worker";
import { SW_CORE_GUARD } from "./core-guard.token";
import { SwUpdateService } from "./update.service";

export function provideServiceWorkerCore(): (EnvironmentProviders | Provider)[] {
    return [
        SwUpdateService,
        provideServiceWorker("ngsw-worker.js", {
            enabled: !isDevMode(),
            registrationStrategy: "registerWhenStable:30000"
        }),
        {
            provide: SW_CORE_GUARD,
            useValue: "SW_CORE_GUARD"
        },
        provideEnvironmentInitializer(() => {
                const swCoreGuard = inject(SW_CORE_GUARD, {
                    skipSelf: true,
                    optional: true
                });

                if (swCoreGuard) {
                    throw new TypeError("provideServiceWorkerCore cannot load more than once.");
                }

                inject(SwUpdateService).init();
            })
    ];
}
